import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  btnVoltarText: {
    fontSize: 18,
    color: "#077A97",
    textTransform: "uppercase",
  },

  btnVoltar: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    backgroundColor: "#FFF",
    marginBottom: 20,
    alignSelf: "center",
  },
});

export default styles;
